"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function onLoad() {
    const collapsableGridHeadings = document.querySelectorAll('.grid-header__collapsable[aria-expanded]');
    collapsableGridHeadings.forEach(heading => {
        const gridHeading = heading;
        gridHeading.addEventListener("click", onGridHeadingClick);
        if (gridHeading.nextElementSibling) {
            const content = gridHeading.nextElementSibling;
            // set default expanded
            const expanded = gridHeading.getAttribute("aria-expanded");
            content.style.maxHeight = expanded === "false" ? "0px" : content.scrollHeight + "px";
        }
    });
}
function onGridHeadingClick() {
    const expanded = this.getAttribute('aria-expanded');
    this.setAttribute('aria-expanded', expanded === "true" ? "false" : "true");
    if (this.nextElementSibling) {
        const content = this.nextElementSibling;
        content.style.maxHeight = content.style.maxHeight !== "0px" ? "0px" : content.scrollHeight + "px";
    }
}
document.addEventListener('DOMContentLoaded', onLoad);
